export const titles = [
  {
    id: "m1",
    type: "movie",
    title: "星际孤旅",
    year: 2026,
    region: "中国大陆",
    genres: ["科幻", "冒险", "剧情"],
    director: "周砚",
    cast: ["林知远", "苏晚", "陈默"],
    synopsis:
      "深空探测船“归途号”完成第七次跃迁后与地球彻底失去联络，船上十二名科研人员只剩下导航员陆行一人醒来。他必须在氧气耗尽前查明同伴失踪的真相，并决定是继续驶向那颗编号 X-19 的蓝色行星，还是掉头回到一片沉默的故土。",
    highlights:
      "全片以极简的太空场景与大量静默镜头构成，用光线的明暗代替对白，讲述人在无边黑暗中如何依靠记忆确认自己仍然活着。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20cinematic%20sci-fi%20movie%20poster%20art%2C%20lone%20astronaut%20silhouette%20before%20a%20giant%20blue%20planet%2C%20deep%20navy%20background%2C%20warm%20amber%20rim%20light%2C%20subtle%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-m1&orientation=portrait",
    hot: 96,
    duration: "128分钟",
  },
  {
    id: "m2",
    type: "movie",
    title: "雨夜告白",
    year: 2025,
    region: "中国大陆",
    genres: ["爱情", "剧情"],
    director: "沈嘉言",
    cast: ["苏晚", "顾南川", "白露"],
    synopsis:
      "旧城区最后一间唱片行即将关门，店主程一在整理库存时翻出一盘没有署名的磁带。磁带里是一个女孩在雨夜里断断续续的告白，而声音的主人正是三年前不告而别的搭档。一场关于告别与重逢的雨，从傍晚下到了天亮。",
    highlights:
      "以一间唱片行、一条老街和一场漫长的雨搭起全部叙事空间，把城市里最普通的心动拍得克制又诚实。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20romantic%20drama%20movie%20poster%20art%2C%20couple%20under%20one%20umbrella%20on%20a%20rainy%20neon%20street%20at%20night%2C%20deep%20navy%20tones%20with%20warm%20orange%20reflections%2C%20cinematic%20bokeh%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-m2&orientation=portrait",
    hot: 88,
    duration: "112分钟",
  },
  {
    id: "m3",
    type: "movie",
    title: "迷雾追凶",
    year: 2026,
    region: "中国香港",
    genres: ["悬疑", "犯罪", "惊悚"],
    director: "陈启峰",
    cast: ["江野", "温以宁", "程野"],
    synopsis:
      "港口连续七个雾夜出现同一艘无人渔船，船上只留下一枚停摆在凌晨三点的旧怀表。退休刑警黎闯被请回警局做最后一份档案整理，却发现自己二十年前未结的那桩案子，正以完全相同的方式重新上演。",
    highlights:
      "潮湿的雾、老式码头与层层嵌套的时间线，构成一部几乎没有喘息空间的追凶之作，结尾的反转克制却致命。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20crime%20thriller%20movie%20poster%20art%2C%20detective%20silhouette%20in%20thick%20fog%20on%20a%20harbor%20pier%2C%20deep%20navy%20and%20dark%20teal%20palette%2C%20single%20amber%20street%20lamp%2C%20cinematic%20mystery%20mood%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-m3&orientation=portrait",
    hot: 93,
    duration: "121分钟",
  },
  {
    id: "m4",
    type: "movie",
    title: "夏日回声",
    year: 2025,
    region: "日本",
    genres: ["青春", "剧情"],
    director: "森川凉",
    cast: ["佐野遥", "高桥直人", "小林葵"],
    synopsis:
      "海边小镇的夏天总有一场不期而至的台风。转学而来的少女纱耶在废弃的广播站里发现一台还能使用的老式发射机，她开始每天傍晚对着空频道念一段日记，却意外收到了来自十年前的回信。",
    highlights:
      "用声音代替画面去记忆夏天，海风、蝉鸣与广播杂音交织成一部关于时间错位的温柔小品。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20coming%20of%20age%20film%20poster%20art%2C%20teenager%20on%20a%20seaside%20pier%20at%20golden%20hour%2C%20deep%20blue%20sky%20with%20warm%20amber%20sunlight%2C%20nostalgic%20summer%20atmosphere%2C%20cinematic%20grain%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-m4&orientation=portrait",
    hot: 82,
    duration: "106分钟",
  },
  {
    id: "m5",
    type: "movie",
    title: "笑到最后",
    year: 2026,
    region: "中国大陆",
    genres: ["喜剧", "家庭"],
    director: "罗嘉",
    cast: ["罗嘉", "许清和", "于晚舟"],
    synopsis:
      "一家开了三十年的老剧场接到拆迁通知，老板决定用最后一场演出把票全部卖完。演员是隔壁退休的裁缝、送外卖的青年和一位从没上过台的会计，他们决定演一出关于自己的戏。",
    highlights:
      "从排练到开演，全片用大量即兴感十足的对手戏撑住了笑点，也在最后一幕悄悄把观众按在了椅子上。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20warm%20comedy%20movie%20poster%20art%2C%20empty%20vintage%20theater%20stage%20with%20a%20single%20warm%20spotlight%2C%20red%20velvet%20seats%2C%20deep%20navy%20shadows%20and%20amber%20light%2C%20cinematic%20composition%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-m5&orientation=portrait",
    hot: 85,
    duration: "118分钟",
  },
  {
    id: "m6",
    type: "movie",
    title: "深海灯塔",
    year: 2024,
    region: "韩国",
    genres: ["灾难", "剧情"],
    director: "朴允锡",
    cast: ["郑元", "柳瑞妍", "崔成浩"],
    synopsis:
      "一场罕见的海底地震切断了孤岛与外界的联系，灯塔守护人必须在潮水淹没机房前重启信号灯。岛上的十七位居民被困在最高处，而唯一的救援船要六小时后才能抵达。",
    highlights:
      "实景拍摄的暴风雨与手摇镜头带来近乎生理性的紧张感，而真正动人的是灯亮起时所有人同时抬头的那一秒。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20disaster%20drama%20movie%20poster%20art%2C%20lighthouse%20in%20a%20violent%20storm%20at%20night%2C%20huge%20dark%20waves%2C%20single%20amber%20beam%20cutting%20through%20deep%20navy%20rain%2C%20cinematic%20realism%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-m6&orientation=portrait",
    hot: 90,
    duration: "132分钟",
  },
  {
    id: "m7",
    type: "movie",
    title: "长街旧梦",
    year: 2025,
    region: "中国大陆",
    genres: ["年代", "剧情"],
    director: "何砚",
    cast: ["许南枝", "何砚", "林澈"],
    synopsis:
      "上世纪八十年代，南方小城的一条长街上住着照相馆、钟表铺和一家只有两台缝纫机的裁缝店。三个年轻人各自带着想去远方的念头，却在同一年的冬天做了完全不同的选择。",
    highlights:
      "胶片质感的画面与大量生活细节，把一条街的兴衰拍成了一代人的集体回忆录。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20nostalgic%20period%20drama%20poster%20art%2C%20old%20Chinese%20street%20with%20photo%20studio%20and%20bicycles%20at%20dusk%2C%20warm%20amber%20lamplight%2C%20deep%20blue%20evening%20shadows%2C%20film%20grain%20texture%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-m7&orientation=portrait",
    hot: 79,
    duration: "126分钟",
  },
  {
    id: "m8",
    type: "movie",
    title: "极速边界",
    year: 2026,
    region: "美国",
    genres: ["动作", "赛车"],
    director: "Marcus Vale",
    cast: ["Dean Reyes", "Nina Cole", "Owen Park"],
    synopsis:
      "退役车手凯尔被老队友拉回赛道，任务是驾驶一台尚未通过测试的原型车完成横跨三州的非法接力。他很快发现，这场比赛的终点并不是奖金，而是一份足以掀翻整个车队的证据。",
    highlights:
      "几乎全部由实拍车戏构成，隧道、盐湖与夜雨的三种路况拍出了完全不同的速度感。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20action%20racing%20movie%20poster%20art%2C%20black%20prototype%20sports%20car%20speeding%20through%20a%20rainy%20tunnel%2C%20streaking%20amber%20light%20trails%2C%20deep%20navy%20shadows%2C%20high%20contrast%20cinematic%20look%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-m8&orientation=portrait",
    hot: 91,
    duration: "116分钟",
  },
  {
    id: "m9",
    type: "movie",
    title: "山海图卷",
    year: 2025,
    region: "中国大陆",
    genres: ["动画", "奇幻"],
    director: "顾青",
    cast: ["宋疏影", "蒋雪", "程野"],
    synopsis:
      "修复古画的少女在深夜被卷入一幅未完成的山海长卷，卷中每一座山都缺了一角，每一只异兽都在等待自己的名字被写下。她必须在画魂消散之前，把整幅画补完。",
    highlights:
      "水墨与三维结合的视觉实验，山峦会呼吸，云海会呼吸，整部影片像一次缓慢展开的东方想象。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20animated%20fantasy%20film%20poster%20art%2C%20ancient%20Chinese%20ink%20painting%20scroll%20mountains%20with%20a%20white%20mythical%20beast%2C%20deep%20navy%20night%20sky%20and%20warm%20amber%20glow%2C%20elegant%20oriental%20aesthetic%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-m9&orientation=portrait",
    hot: 87,
    duration: "104分钟",
  },
  {
    id: "t1",
    type: "tv",
    title: "长夜将明",
    year: 2026,
    region: "中国大陆",
    genres: ["悬疑", "刑侦", "剧情"],
    director: "郑放",
    cast: ["江野", "温以宁", "林澈", "程野"],
    synopsis:
      "一起发生在十六年前的失踪案重新被翻开，负责复核的年轻警官发现，当年所有证人都在同一天改了口供。随着夜里的一通匿名电话打进值班室，整座城市的旧关系开始一寸寸松动。",
    highlights:
      "双线叙事在第八集完成交汇，前半段所有的沉默都成为后半段的证词，是近年少见的慢燃型刑侦剧。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20crime%20series%20poster%20art%2C%20empty%20police%20station%20corridor%20at%20midnight%20with%20one%20warm%20lamp%2C%20deep%20navy%20shadows%2C%20rain%20on%20the%20windows%2C%20cinematic%20tension%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-t1&orientation=portrait",
    hot: 97,
    episodeCount: 24,
    episodeNote: "全24集 · 已完结",
    episodes: [
      { id: "t1-e1", title: "第1集 夜班来电", summary: "值班室接到一通只响三秒的电话，来电号码属于十六年前的失踪者。" },
      { id: "t1-e2", title: "第2集 改口", summary: "卷宗显示，当年七位证人在同一日修改了证词，理由栏全部空白。" },
      { id: "t1-e3", title: "第3集 旧仓库", summary: "废弃仓库里找到的校服外套，让案件的年代往前推了三年。" },
      { id: "t1-e4", title: "第4集 雾中人", summary: "大雾封城，一名关键证人在回家路上失踪，监控只拍到半秒背影。" },
      { id: "t1-e5", title: "第5集 第二份笔录", summary: "档案室失火后，一份从未归档的第二份笔录流到了记者手里。" },
      { id: "t1-e6", title: "第6集 同一天", summary: "所有线索指向同一天，而那天发生的事，被所有人默契地避开。" },
      { id: "t1-e7", title: "第7集 沉默的代价", summary: "老刑警交出封存多年的录音带，代价是自己站上了被调查的位置。" },
      { id: "t1-e8", title: "第8集 长夜将明", summary: "真凶现身于清晨第一班渡轮上，天光与证词同时抵达。" },
    ],
  },
  {
    id: "t2",
    type: "tv",
    title: "春山书院",
    year: 2025,
    region: "中国大陆",
    genres: ["古装", "权谋", "剧情"],
    director: "周砚",
    cast: ["许南枝", "顾南川", "何砚", "沈知夏"],
    synopsis:
      "春山书院迎来新一届学子，寒门出身的少女沈知夏以一篇策论震动朝野，也把自己推到了新旧两派角力的中心。书院里的一纸课业，往往决定京城里的一场风雨。",
    highlights:
      "以书院为切口讲朝堂，把辩论、课业与人情往来拍得极为好看，服化道与礼制细节考究。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20historical%20Chinese%20drama%20poster%20art%2C%20ancient%20academy%20courtyard%20with%20lanterns%20and%20pine%20trees%2C%20figure%20in%20hanfu%20seen%20from%20behind%2C%20deep%20navy%20night%20and%20warm%20amber%20lantern%20glow%2C%20elegant%20cinematic%20composition%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-t2&orientation=portrait",
    hot: 94,
    episodeCount: 36,
    episodeNote: "全36集 · 已完结",
    episodes: [
      { id: "t2-e1", title: "第1集 入学策论", summary: "一篇谈论盐政的策论让寒门少女越过三甲，也让主考官脸色大变。" },
      { id: "t2-e2", title: "第2集 春山夜雨", summary: "书院第一次夜试，题目出自一本被列为禁书的旧集。" },
      { id: "t2-e3", title: "第3集 同窗", summary: "四位同窗结下情谊，各自背后却站着立场不同的家族。" },
      { id: "t2-e4", title: "第4集 无字碑", summary: "后山无字碑上的拓片，牵出二十年前一桩旧案。" },
      { id: "t2-e5", title: "第5集 论辩", summary: "一场关于税制的辩难，让沈知夏第一次被推到众人面前。" },
      { id: "t2-e6", title: "第6集 山长", summary: "山长病重，书院继承人的名字被写在了一封没有寄出的信里。" },
      { id: "t2-e7", title: "第7集 旧卷", summary: "旧卷重见天日，有人连夜烧毁家书，有人选择公开承认。" },
      { id: "t2-e8", title: "第8集 春山再见", summary: "放榜之日，书院众人在山门前立誓，各有去路。" },
    ],
  },
  {
    id: "t3",
    type: "tv",
    title: "我们的小城",
    year: 2025,
    region: "中国大陆",
    genres: ["现代", "家庭", "生活"],
    director: "沈嘉言",
    cast: ["白露", "罗嘉", "于晚舟", "蒋雪"],
    synopsis:
      "一家开了二十年的早餐店要搬迁，三代人因此重新聚在同一张桌子上。母亲想守住老味道，儿子想贷款换个大铺面，而刚上高中的孙女只关心自己的画笔会不会被收走。",
    highlights:
      "几乎没有激烈冲突，全靠一日三餐和细碎的对话推进，是一部适合慢慢看的生活流剧集。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20family%20life%20drama%20poster%20art%2C%20steaming%20breakfast%20shop%20at%20early%20morning%20in%20a%20small%20Chinese%20town%2C%20warm%20amber%20steam%20and%20deep%20navy%20dawn%20shadows%2C%20cozy%20realistic%20cinematic%20look%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-t3&orientation=portrait",
    hot: 86,
    episodeCount: 30,
    episodeNote: "全30集 · 已完结",
    episodes: [
      { id: "t3-e1", title: "第1集 乔迁通知", summary: "一张贴在卷帘门上的通知，让一家人的早饭吃得格外沉默。" },
      { id: "t3-e2", title: "第2集 老味道", summary: "母亲坚持不换配方，顾客却悄悄说起新开的连锁店。" },
      { id: "t3-e3", title: "第3集 贷款", summary: "儿子拿回一份贷款方案，签字那一栏最终空着。" },
      { id: "t3-e4", title: "第4集 画笔", summary: "孙女的画被老师推荐参赛，家里人却为学费争执了一晚。" },
      { id: "t3-e5", title: "第5集 常客", summary: "每天坐角落的老先生缺席了三天，早餐店第一次觉得空。" },
      { id: "t3-e6", title: "第6集 新铺面", summary: "新铺面签下来了，老邻居们凑钱送来一块旧招牌。" },
      { id: "t3-e7", title: "第7集 一碗面", summary: "母子俩在打烊后的厨房里，终于把话说完了。" },
      { id: "t3-e8", title: "第8集 我们的小城", summary: "新店开业那天，小城的早晨还是原来的味道。" },
    ],
  },
  {
    id: "t4",
    type: "tv",
    title: "霓虹之下",
    year: 2026,
    region: "中国香港",
    genres: ["都市", "悬疑"],
    director: "陈启峰",
    cast: ["程野", "唐屿", "郑元", "温以宁"],
    synopsis:
      "深夜的旺角，一间二十四小时洗衣店成了几个陌生人共同的落脚点。收银台后那本被反复翻看的记事簿，记录着每个人不愿提起的夜晚，也记录着一桩尚未被报案的失踪。",
    highlights:
      "霓虹、雨夜与狭小空间构成的港味悬疑，节奏快，信息量大，群像塑造尤其出色。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20urban%20mystery%20series%20poster%20art%2C%20Hong%20Kong%20neon%20street%20at%20night%20reflected%20in%20rain%20puddles%2C%20deep%20navy%20shadows%20with%20warm%20orange%20neon%20signs%2C%20moody%20cinematic%20composition%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-t4&orientation=portrait",
    hot: 92,
    episodeCount: 20,
    episodeNote: "全20集 · 已完结",
    episodes: [
      { id: "t4-e1", title: "第1集 洗衣店", summary: "凌晨两点，一个浑身湿透的人推门进来，只要求洗一件外套。" },
      { id: "t4-e2", title: "第2集 记事簿", summary: "收银台下的记事簿，写着七个陌生人的名字与日期。" },
      { id: "t4-e3", title: "第3集 电梯", summary: "同一栋唐楼的电梯在十三层停了四分钟，监控却是空的。" },
      { id: "t4-e4", title: "第4集 旧照片", summary: "一张十年前的照片，让洗衣店老板第一次关掉了店门。" },
      { id: "t4-e5", title: "第5集 雨停之前", summary: "所有人在同一夜回到洗衣店，雨下得比预报更大。" },
      { id: "t4-e6", title: "第6集 证人", summary: "唯一愿意开口的人，提出了一个交换条件。" },
      { id: "t4-e7", title: "第7集 霓虹熄灭", summary: "整条街停电，黑暗中有人说出了真相的一半。" },
      { id: "t4-e8", title: "第8集 天亮以后", summary: "招牌重新亮起时，记事簿上多了一行空白的日期。" },
    ],
  },
  {
    id: "t5",
    type: "tv",
    title: "十七岁的夏天",
    year: 2024,
    region: "韩国",
    genres: ["青春", "校园"],
    director: "朴允锡",
    cast: ["柳瑞妍", "郑元", "崔成浩"],
    synopsis:
      "高二的最后一个学期，五个被分到同一组的同学要一起完成一份关于“十年后的自己”的作业。他们在旧相机、天台和便利店之间，慢慢把这份作业拍成了真实的夏天。",
    highlights:
      "干净的色调与不刻意煽情的对白，把青春里那些说不出口的心事拍得非常准。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20youth%20school%20drama%20poster%20art%2C%20students%20on%20a%20school%20rooftop%20at%20sunset%20with%20a%20vintage%20camera%2C%20deep%20blue%20sky%20and%20warm%20amber%20sunlight%2C%20soft%20nostalgic%20film%20look%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-t5&orientation=portrait",
    hot: 80,
    episodeCount: 16,
    episodeNote: "全16集 · 已完结",
    episodes: [
      { id: "t5-e1", title: "第1集 分组", summary: "一份关于十年后的作业，把五个不相熟的人分到了一起。" },
      { id: "t5-e2", title: "第2集 旧相机", summary: "在天台储物柜里找到的相机，还剩最后三张底片。" },
      { id: "t5-e3", title: "第3集 便利店的夜", summary: "补习结束后的深夜便利店，成了他们的临时剪辑室。" },
      { id: "t5-e4", title: "第4集 第一次争执", summary: "拍摄方向上的分歧，让小组第一次真正吵了起来。" },
      { id: "t5-e5", title: "第5集 下雨的操场", summary: "一场雨取消了比赛，也留下了一段谁都没提的对话。" },
      { id: "t5-e6", title: "第6集 十年后", summary: "他们试着演出十年后的自己，却发现台词怎么都不对。" },
      { id: "t5-e7", title: "第7集 最后三张", summary: "底片冲洗出来，画面里多了一个不在场的人。" },
      { id: "t5-e8", title: "第8集 夏天结束", summary: "作业放映结束，夏天也到了该说再见的时候。" },
    ],
  },
  {
    id: "t6",
    type: "tv",
    title: "远洋来信",
    year: 2025,
    region: "中国大陆",
    genres: ["年代", "情感", "剧情"],
    director: "何砚",
    cast: ["沈知夏", "顾南川", "宋疏影"],
    synopsis:
      "九十年代初，一封从远洋货轮寄出的信落在了小镇邮局。代笔的邮局职员替不识字的收信人读了信，也从此被卷进了一段横跨十年的等待里。",
    highlights:
      "以信件为线索串联起小镇、港口与远方的海，台词朴素，情绪后劲很足。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20period%20romance%20drama%20poster%20art%2C%20handwritten%20letters%20and%20a%20vintage%20bicycle%20in%20a%20small%20seaside%20post%20office%2C%20warm%20amber%20lamplight%20with%20deep%20navy%20evening%20tones%2C%20nostalgic%20film%20grain%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-t6&orientation=portrait",
    hot: 84,
    episodeCount: 28,
    episodeNote: "全28集 · 已完结",
    episodes: [
      { id: "t6-e1", title: "第1集 一封来信", summary: "邮局职员第一次替人读信，就读到了一段不该被公开的心事。" },
      { id: "t6-e2", title: "第2集 代笔", summary: "她开始替人回信，也在信里悄悄写下了自己想说的话。" },
      { id: "t6-e3", title: "第3集 港口", summary: "货轮靠岸三天，寄信的人却没有下船。" },
      { id: "t6-e4", title: "第4集 十年之约", summary: "信里提到一个十年后的约定，收信人笑着说不必当真。" },
      { id: "t6-e5", title: "第5集 邮包", summary: "一个没有寄件人姓名的邮包，让整个邮局沉默了整晚。" },
      { id: "t6-e6", title: "第6集 风浪", summary: "远洋航线出了事故，小镇上的人开始每天守在收音机前。" },
      { id: "t6-e7", title: "第7集 旧邮票", summary: "一枚旧邮票揭开了代笔多年的秘密。" },
      { id: "t6-e8", title: "第8集 回信", summary: "多年以后，终于有人替那段等待写下回信。" },
    ],
  },
  {
    id: "t7",
    type: "tv",
    title: "静默信号",
    year: 2026,
    region: "美国",
    genres: ["科幻", "惊悚"],
    director: "Evan Cross",
    cast: ["Dean Reyes", "Nina Cole", "Owen Park"],
    synopsis:
      "全球所有的无线电在同一分钟安静下来，只有一座山谷里的小型观测站仍能收到一段重复的脉冲信号。三名值守人员必须在七天之内判断：那到底是自然的回声，还是某种回应。",
    highlights:
      "极简场景与高压氛围，靠声音设计和极少的台词制造恐惧，越到后面越安静。",
    poster:
      "https://readdy.ai/api/search-image?query=Vertical%20sci-fi%20thriller%20series%20poster%20art%2C%20radio%20telescope%20dish%20in%20a%20silent%20dark%20valley%20at%20night%2C%20deep%20navy%20sky%20with%20a%20single%20amber%20signal%20glow%2C%20cold%20atmospheric%20cinematic%20mood%2C%20no%20text%2C%20no%20lettering&width=600&height=800&seq=poster-t7&orientation=portrait",
    hot: 89,
    episodeCount: 10,
    episodeNote: "全10集 · 已完结",
    episodes: [
      { id: "t7-e1", title: "第1集 白噪音", summary: "全球无线电静默的第一分钟，山谷里收到了一段规律的脉冲。" },
      { id: "t7-e2", title: "第2集 七天", summary: "总部要求他们在七天内给出结论，补给却只够五天。" },
      { id: "t7-e3", title: "第3集 回声", summary: "脉冲出现了第二层结构，像是在等待回复。" },
      { id: "t7-e4", title: "第4集 记录员", summary: "一名值守人员开始记录自己的梦境，内容与信号完全一致。" },
      { id: "t7-e5", title: "第5集 断联", summary: "通讯彻底中断，观测站成了山谷里唯一的孤岛。" },
      { id: "t7-e6", title: "第6集 回复", summary: "他们决定发送一段回复，代价是暴露观测站的位置。" },
      { id: "t7-e7", title: "第7集 静默", summary: "信号停止，山谷安静得让所有人都不敢入睡。" },
      { id: "t7-e8", title: "第8集 第七天", summary: "第七天清晨，天线上出现了不属于他们的东西。" },
    ],
  },
];